import script from "./BlockTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockTitle.vue?vue&type=script&setup=true&lang=js"

import "./BlockTitle.vue?vue&type=style&index=0&id=019ac0a2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-019ac0a2"]])

export default __exports__